webpackJsonp([2],{

/***/ 24:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * REMOVE WHEN IE 11 USAGE DROPS
 */

/**
 * ChildNode.remove()
 * https://developer.mozilla.org/en-US/docs/Web/API/ChildNode/remove#Polyfill
 */
(function (arr) {
  arr.forEach(function (item) {
    if (item.hasOwnProperty('remove')) {
      return;
    }
    Object.defineProperty(item, 'remove', {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function remove() {
        this.parentNode.removeChild(this);
      }
    });
  });
})([Element.prototype, CharacterData.prototype, DocumentType.prototype]);

/**
 * Object.assign()
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign#Polyfill
 */
if (typeof Object.assign != 'function') {
  Object.assign = function (target, varArgs) {
    // .length of function is 2
    'use strict';

    if (target == null) {
      // TypeError if undefined or null
      throw new TypeError('Cannot convert undefined or null to object');
    }

    var to = Object(target);

    for (var index = 1; index < arguments.length; index++) {
      var nextSource = arguments[index];

      if (nextSource != null) {
        // Skip over if undefined or null
        for (var nextKey in nextSource) {
          // Avoid bugs when hasOwnProperty is shadowed
          if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
            to[nextKey] = nextSource[nextKey];
          }
        }
      }
    }
    return to;
  };
}

/***/ }),

/***/ 25:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(24);

module.exports = function () {
  document.querySelector('.page-loader').remove();
};

/***/ }),

/***/ 31:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var cookies = __webpack_require__(34);

/**
 * Load, get, set, and save settings.
 */
module.exports = {
  _settings: {},
  _defaults: {
    sites: ['ancestry', 'familysearch', 'findmypast.co.uk', 'findagrave', 'google', 'myheritage']
  },
  load: function load() {
    var cookie = cookies.getItem('settings'),
        parsed = {};
    if (cookie) {
      try {
        parsed = JSON.parse(cookie);
      } catch (e) {}
    }
    // TODO: updated to remove dependency on lodash. This won't scale well with
    // additional properties.
    this._settings.sites = parsed.sites || this._defaults.sites;
  },
  save: function save() {
    cookies.setItem('settings', JSON.stringify(this._settings), Infinity);
  },
  get: function get(key) {
    return this._settings[key];
  },
  set: function set(key, value) {
    this._settings[key] = value;
  }
};

/***/ }),

/***/ 34:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * https://developer.mozilla.org/en-US/docs/Web/API/Document/cookie
 */
module.exports = {
  getItem: function getItem(sKey) {
    if (!sKey) {
      return null;
    }
    return decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) || null;
  },
  setItem: function setItem(sKey, sValue, vEnd, sPath, sDomain, bSecure) {
    if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) {
      return false;
    }
    var sExpires = "";
    if (vEnd) {
      switch (vEnd.constructor) {
        case Number:
          sExpires = vEnd === Infinity ? "; expires=Fri, 31 Dec 9999 23:59:59 GMT" : "; max-age=" + vEnd;
          break;
        case String:
          sExpires = "; expires=" + vEnd;
          break;
        case Date:
          sExpires = "; expires=" + vEnd.toUTCString();
          break;
      }
    }
    document.cookie = encodeURIComponent(sKey) + "=" + encodeURIComponent(sValue) + sExpires + (sDomain ? "; domain=" + sDomain : "") + (sPath ? "; path=" + sPath : "") + (bSecure ? "; secure" : "");
    return true;
  },
  removeItem: function removeItem(sKey, sPath, sDomain) {
    if (!this.hasItem(sKey)) {
      return false;
    }
    document.cookie = encodeURIComponent(sKey) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT" + (sDomain ? "; domain=" + sDomain : "") + (sPath ? "; path=" + sPath : "");
    return true;
  },
  hasItem: function hasItem(sKey) {
    if (!sKey) {
      return false;
    }
    return new RegExp("(?:^|;\\s*)" + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=").test(document.cookie);
  },
  keys: function keys() {
    var aKeys = document.cookie.replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g, "").split(/\s*(?:\=[^;]*)?;\s*/);
    for (var nLen = aKeys.length, nIdx = 0; nIdx < nLen; nIdx++) {
      aKeys[nIdx] = decodeURIComponent(aKeys[nIdx]);
    }
    return aKeys;
  }
};

/***/ }),

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Settings = __webpack_require__(31),
    gensites = __webpack_require__(54),
    gensearch = __webpack_require__(90),
    React = __webpack_require__(33),
    ReactDOM = __webpack_require__(32),
    loaded = __webpack_require__(25);

/**
 * Manage a site's display and settings
 */

var SearchSite = function (_React$Component) {
  _inherits(SearchSite, _React$Component);

  function SearchSite(props) {
    _classCallCheck(this, SearchSite);

    var _this = _possibleConstructorReturn(this, (SearchSite.__proto__ || Object.getPrototypeOf(SearchSite)).call(this, props));

    _this.click = _this.click.bind(_this);
    return _this;
  }

  _createClass(SearchSite, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: 'col-xs-12 col-sm-6 col-lg-4' },
        React.createElement(
          'button',
          { className: 'site btn btn-lg btn-default', onClick: this.click },
          React.createElement(
            'div',
            { className: 'site-name' },
            this.props.site.name
          ),
          React.createElement(
            'div',
            { className: 'site-search-btn' },
            React.createElement('span', { className: 'glyphicon glyphicon-search' })
          )
        )
      );
    }
  }, {
    key: 'click',
    value: function click() {
      search(this.props.site.id);
    }
  }]);

  return SearchSite;
}(React.Component);

function getPersonFormData() {
  var data = {},
      inputs = document.querySelectorAll('#search-form input');
  var prop = void 0;
  // Can't use Array.from() because of IE 11. Using forEach.call() is much
  // lighter than a polyfill.
  Array.prototype.forEach.call(inputs, function (input) {
    prop = input.id.split('_')[1];
    data[prop] = input.value;
  });
  return data;
}

function search(site) {
  var data = getPersonFormData(),
      url = gensearch(site, data);
  window.open(url, '_blank');
  ga('send', 'event', 'search', 'site', site);
}

document.addEventListener("DOMContentLoaded", function () {
  Settings.load();

  var sites = Settings.get('sites').filter(function (site) {
    return gensites.site(site) && gensearch.sites[site];
  }).map(function (site) {
    return gensites.site(site);
  }).map(function (site) {
    return React.createElement(SearchSite, { key: site.id, site: site });
  });

  ReactDOM.render(React.createElement(
    'div',
    null,
    sites
  ), document.getElementById('sites-list'));

  var isData = false,
      prop = void 0;
  for (prop in personData) {
    document.getElementById('data_' + prop).value = personData[prop];
    isData = true;
  }

  if (isData) {
    ga('send', 'event', 'search', 'dataLoaded');
  } else {
    ga('send', 'event', 'search', 'noData');
  }

  loaded();
});

/***/ })

},[91]);


// WEBPACK FOOTER //
// search.js